// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PotentialInvoicesToCreditQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  stage: Types.Stage;
}>;


export type PotentialInvoicesToCreditQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, name: string, creditForInvoice?: { __typename?: 'Invoice', id: string } | null | undefined }> };


export const PotentialInvoicesToCreditDocument = gql`
    query PotentialInvoicesToCredit($projectId: ID!, $stage: Stage!) {
  invoices(
    filter: {status: [APPROVED, REQUESTED], projectId: [$projectId], stage: [$stage]}
  ) {
    id
    name
    creditForInvoice {
      id
    }
  }
}
    `;

/**
 * __usePotentialInvoicesToCreditQuery__
 *
 * To run a query within a React component, call `usePotentialInvoicesToCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialInvoicesToCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialInvoicesToCreditQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function usePotentialInvoicesToCreditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables> & ({ variables: PotentialInvoicesToCreditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>(PotentialInvoicesToCreditDocument, options);
      }
export function usePotentialInvoicesToCreditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>(PotentialInvoicesToCreditDocument, options);
        }
// @ts-ignore
export function usePotentialInvoicesToCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>;
export function usePotentialInvoicesToCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PotentialInvoicesToCreditQuery | undefined, PotentialInvoicesToCreditQueryVariables>;
export function usePotentialInvoicesToCreditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>(PotentialInvoicesToCreditDocument, options);
        }
export type PotentialInvoicesToCreditQueryHookResult = ReturnType<typeof usePotentialInvoicesToCreditQuery>;
export type PotentialInvoicesToCreditLazyQueryHookResult = ReturnType<typeof usePotentialInvoicesToCreditLazyQuery>;
export type PotentialInvoicesToCreditSuspenseQueryHookResult = ReturnType<typeof usePotentialInvoicesToCreditSuspenseQuery>;
export type PotentialInvoicesToCreditQueryResult = ApolloReactCommon.QueryResult<PotentialInvoicesToCreditQuery, PotentialInvoicesToCreditQueryVariables>;